import {useState} from 'react';
import styles from './SlotMachine.module.css';
import './styles.css';

import {SlotMachineGraphic} from './components/Graphic';
import Video from './components/Video';
import SlotMachineLayout from '../slot-machine-wrapper/SlotMachineLayout';
import bushCenter from 'assets/games/theme-car-stream/slot/footer/footer.png';

export default function SlotMachineCarStream() {
    const [bgMusicMuted, setBgMusicMuted] = useState(false);

    return (
        <div className={styles.slotMachineContainer}>
            <SlotMachineLayout
                BgWrapper={({children}) => (
                    <div className={styles.slotMachineBg}>
                        {children}
                    </div>
                )}

                InnerWrapper={({children}) => (
                    <div className={styles.SlotMachineInnerContainer}>
                        {children}
                    </div>
                )}
                background={
                    <>
                        <div className={styles.lightBulbOne}/>
                        <div className={styles.lightBulbTwo}/>
                        <div className={styles.lightBulbThree}/>
                        <div className={styles.lightBulbFour}/>
                    </>
                }

                graphic={
                    <SlotMachineGraphic/>
                }


                video={
                    <Video bgMusicMuted={bgMusicMuted}/>
                }

                footer={
                    <div className={styles.SlotMachineFooter}>
                        <img src={bushCenter} alt="LMCT+" className={styles.SlotMachineFooterCenterBush}/>
                    </div>
                }

            />
        </div>
    );
}
